import React from 'react';
import { PPTDemoMode, type IBatchTemplateData } from '@meitu/saas-editor-core/es/version-types';
import NavigationCollapseComp from '@meitu/saas-editor-ui/es/collapses/navigation';
import { checkTypeIsAiPPT } from '@meitu/saas-editor-ui/es/utils/stage';
import { events } from '@/events-bus';
import { packageTemplateConf } from '@/hooks/fetch-template';
// import { checkIsCover, useInitPPT } from '@/hooks/fetch-template/init-ppt';
import { getStagePoints, replaceComponentKit } from '@/hooks/fetch-template/ppt-template/replace-ppt-component';
import { transferTemplateToClient } from '@/hooks/fetch-template/server-to-client';
import { editor } from '@/instance';
import { useCollapseModel } from '@/store/collapse-models/collapse-model';
import { useNavigationCollapseModel } from '@/store/collapse-models/navigation-collapse-model';
import { useEditorModel } from '@/store/models/editor-model';
import { usePptCreateTipModel } from '@/store/models/ppt-create-tip-model';
import { useRecordModel } from '@/store/models/record-model';
import { useTemplateModel } from '@/store/models/template-model';
// import {
//     fetchAIPPTComponentList,
//     fetchPPTApplyItem,
//     fetchPPTCheckItemProcess,
//     fetchPPTItemDetail,
// } from '@/services/ppt';
import { checkImageEditor, isFromHuaweiCustom } from '@/utils/common';
import { getCurrentScene } from '@/utils/track';
import { transferIdParams } from '@/utils/transfer-id';

const NavigationCollapse = () => {
    const setCurrentType = useCollapseModel((state) => state.setCurrentType);
    const currentType = useCollapseModel((state) => state.currentType);
    const canvasType = useTemplateModel((state) => state.canvasType);
    const posterType = useRecordModel((state) => state.posterType);
    const batchTemplateData = useEditorModel((state) => state.batchTemplateData);
    const setBatchTemplateData = useEditorModel((state) => state.setBatchTemplateData);
    const closeAiPPTPrompt = useNavigationCollapseModel((state) => state.closeAiPPTPrompt);
    const stageExtraInfo = useTemplateModel((state) => state.extraInfo);
    const isFullscreen = useEditorModel((state) => state.isFullscreen);
    const subject = useTemplateModel((state) => state.subject);
    const isAiRegen = useNavigationCollapseModel((state) => state.isAiRegen);
    const regenIndex = useNavigationCollapseModel((state) => state.regenIndex);
    const recordId = useRecordModel((state) => state.recordInfo.id);

    const isAiPPT = checkTypeIsAiPPT(posterType);
    const showCreateTip = usePptCreateTipModel((state) => state.show);
    const hideCreateTip = usePptCreateTipModel((state) => state.hide);

    // @TODO 等 pptMode 出来后替换
    const pptMode = 'SPEAKER' as PPTDemoMode;

    const isImageEditor = checkImageEditor();
    // const initPPTHelper = useInitPPT();
    // const initPPT = initPPTHelper.adapter;

    const { setIsAiCreate, setAiRegen } = useNavigationCollapseModel();
    const { isAiCreate } = useNavigationCollapseModel();

    const filterEmptyData = (batchTemplateData: IBatchTemplateData) => {
        let filterData: IBatchTemplateData | null = null;
        const includeColumn = batchTemplateData.headerData.filter((data) => data.labelType);
        const includeRow = batchTemplateData.contentData
            .filter((data) => {
                return data.find((item) => !!item);
            })
            .map((data, index) => {
                return data.filter((item, subIndex) => batchTemplateData.headerData[subIndex]?.labelType);
            });

        filterData = {
            headerData: includeColumn,
            contentData: includeRow,
        };

        return filterData;
    };

    return (
        <NavigationCollapseComp
            editor={editor}
            events={events}
            setCurrentType={setCurrentType}
            currentType={currentType}
            pptMode={pptMode}
            recordId={`${recordId || ''}`}
            setIsAiCreate={setIsAiCreate}
            setAiRegen={setAiRegen}
            isAiPPT={isAiPPT}
            isAiCreate={isAiCreate}
            initPPT={() => {}}
            canvasType={canvasType}
            posterType={posterType}
            batchTemplateData={batchTemplateData}
            setBatchTemplateData={setBatchTemplateData}
            filterEmptyData={filterEmptyData}
            checkIsCover={() => false}
            closeAiPPTPrompt={closeAiPPTPrompt}
            stageExtraInfo={stageExtraInfo}
            getCurrentScene={getCurrentScene}
            isFromHuaweiCustom={isFromHuaweiCustom}
            isImageEditor={isImageEditor}
            transferIdParams={transferIdParams}
            isFullscreen={isFullscreen}
            templateSubject={subject}
            showCreateTip={showCreateTip}
            hideCreateTip={hideCreateTip}
            transferTemplateToClient={transferTemplateToClient}
            packageTemplateConf={packageTemplateConf}
            fetchPPTApplyItem={() => Promise.resolve()}
            fetchPPTCheckItemProcess={() => Promise.resolve()}
            fetchPPTItemDetail={() => Promise.resolve()}
            isAiRegen={isAiRegen}
            regenIndex={regenIndex}
            fetchAIPPTComponentList={() => Promise.resolve()}
            getStagePoints={getStagePoints}
            replaceComponentKit={replaceComponentKit}
        />
    );
};

export default React.memo(NavigationCollapse);
